<template>
  <SoTooltip
    text="Accounts get referred to Moriarty for litigation, sitting between placements. Cannot be edited from here."
  >
    <div
      class="dca-gate"
      :style="{ '--dca-gate-colour': gateColour }"
      :data-testid="`dca-gate-${rowId}`"
    >
      <span class="dca-gate__label">Moriarty</span>
      <SoIcon icon="lock" size="small" class="dca-gate__lock" />
    </div>
  </SoTooltip>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoTooltip from "@/components/SoTooltip.vue"
  import SoIcon from "@/components/SoIcon.vue"
  import { agencyColour, MORIARTY } from "../dcaAgencyColours"

  /**
   * The litigation gate, shown as a locked marker between two placements rather
   * than as a cell.
   *
   * Moriarty is a real step in the journey but not a numbered placement - under
   * the simplified config it no longer consumes a placement number, so a rejected
   * referral and an accepted-then-exhausted one both continue to the same next
   * placement. It has no split to configure: which accounts are referred is owned
   * by the Data-side pipeline, not by this screen. Hence a marker, not a cell.
   */
  export default defineComponent({
    components: { SoTooltip, SoIcon },
    props: {
      rowId: { type: String, required: true },
    },
    computed: {
      /**
       * Taken from the shared agency colours rather than written again here. The gate and
       * the legend show the same agency, and a hardcoded hex in this file was a second
       * source for one fact - already spelt in a different case from the one in
       * dcaAgencyColours, and free to drift from it.
       */
      gateColour(): string {
        return agencyColour(MORIARTY)
      },
    },
  })
</script>

<style scoped>
  .dca-gate {
    /* --dca-gate-colour is bound from agencyColour(MORIARTY) - see the script block. */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    height: 100%;
    min-height: 96px;
    padding: 6px 2px;
    background: rgb(var(--v-theme-surface));
    border: 1px solid var(--dca-gate-colour);
    border-radius: var(--theme-radius);
    cursor: default;
  }

  .dca-gate__label {
    writing-mode: vertical-rl;
    text-orientation: mixed;
    font-size: 8.5px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--dca-gate-colour);
  }

  .dca-gate__lock {
    color: var(--dca-gate-colour);
  }
</style>
